import CAHA1140ResponseModel from '@/api/data/CAH/CAHG1140/CAHA1140ResponseModel'
import CAHA1140RequestModel from '@/api/data/CAH/CAHG1140/CAHA1140RequestModel'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'
import CommonUtil from '@/common/utils/CommonUtil'

export default class CAHG1140Service {
  /**
   * シミュレーションの留意事項
   * @returns base64
   */
  public async callAPICAHA1140(): Promise<CAHA1140ResponseModel> {
    const caha1140RequestModel = new CAHA1140RequestModel()
    const caha1140ResponseModel: CAHA1140ResponseModel = <
      CAHA1140ResponseModel
    > await RestService.post(
      CommonUtil.getApiUrl(ApiUrlConstants.CAHA1140),
      caha1140RequestModel
    )
    return caha1140ResponseModel
  }
}
